<template>
  <v-layout row class="align-center layout px-4 app--page-header">
    <div class="page-header-left">
      <h3 class="pr-3">{{title}}</h3>
    </div>
        <v-breadcrumbs-item>
              <a href="#/"><v-icon small>home</v-icon></a>
        </v-breadcrumbs-item>
      <v-breadcrumbs :items="breadcrumbs" divider="-">
          
          <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>  
    
    <v-spacer></v-spacer>
    <div class="page-header-right">
      <v-btn icon @click="refresh">
        <v-icon class="text--secondary">refresh</v-icon>
      </v-btn>
    </div>
  </v-layout>  
</template>

<script>
export default {
    data () {
        return {
            title: ''
        };
    },
    computed: {
        breadcrumbs: function () {
            let breadcrumbs = [];            
            let route = this.$route.name.split('/');
            var link  = '#'; 
            var path  = '';           
            //this.title = this.$route.title;
            this.setTitle('Home');
            route.forEach((value) => { 
                link += '/'+value;
                path += '/'+value;

                var disabled = true;
                this.$router.options.routes.forEach(route => {
                    if(path === route.path){
                        disabled = false;
                        this.setTitle(route.title || route.name);
                    }  
                });
                breadcrumbs.push({
                    text: value,              
                    href: link,
                    disabled: disabled
                });                   
            });      
            return breadcrumbs;
        }    
    },
    methods:{
        refresh(){
            location.reload();
        },
        setTitle(title){
            this.title = title; 
        }
    }
    
};
</script>
